import React from 'react';
import styled from 'styled-components';
import personalizedPlan from './images/personalized-plan.png';
import { WELCOME_KIT_ITEMS } from './welcomeKit';

const Items = styled.ul`
  list-style: none;
  padding: 0;
  margin: 10px 0 16px;
  border-top: 1px solid #eceef1;
  font-family: Lato, sans-serif;
`;

const Item = styled.li`
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 10px;
  min-height: 60px;
  padding: 8px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #eceef1;
  font-size: 13px;
  line-height: 18px;
  color: #111;

  img { display: block; width: 42px; height: 42px; object-fit: contain; }
`;

// Strikethrough value sits above the "FREE" label (Ethan, Sep 19: "above the
// text instead of on the left"); the same layout on mobile and desktop.
const Value = styled.span`
  justify-self: end;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  white-space: nowrap;
  color: #008427;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;

  s { color: #7a7a7a; font-size: 11px; font-weight: 400; line-height: 13px; }
`;

export function WelcomeKitSummary({ name, isTrial }: { name?: string; isTrial: boolean }) {
  return (
    <Items aria-label="Included with your annual plan">
      {WELCOME_KIT_ITEMS.map(item => (
        <Item key={item.id}>
          <img src={item.image} alt="" />
          <span>{item.name}</span>
          <Value><s>${item.value}</s><span>FREE</span></Value>
        </Item>
      ))}
      <Item>
        <img src={personalizedPlan} alt="" />
        <span>{name?.trim() ? `${name.trim()}'s Personalized Plan` : 'Your Personalized Plan'}</span>
        <Value>{isTrial ? '14 DAYS FREE' : 'INCLUDED'}</Value>
      </Item>
    </Items>
  );
}
